import React from "react";
import { useSelector } from "react-redux";
import { checkReplaceUrl } from "../../utils";
import { useTranslation } from 'react-i18next';

export const SearchSuggestion = ({
  isOpen,
  divRef,
  loading,
  handleSuggestionClick,
  searchQuery,
}) => {
  const suggestion = useSelector((state) => state?.searchLanding?.suggestion);
  const suggestionLoader = useSelector(
    (state) => state?.searchLanding?.suggestion?.isLoading
  );
  const { t } = useTranslation();
  const showDivider = !loading && !suggestionLoader && suggestion?.suggestion?.length > 0 && suggestion?.category?.length > 0;
  const showDividerExploreSupport = !loading && !suggestionLoader && suggestion?.explore?.length > 0 && suggestion?.support?.length > 0;
  return (
    <React.Fragment>
      {isOpen && (
        <div
          ref={divRef}
          className="sd-absolute sd-mt-1 sd-w-full sd-bg-[#FFFCF9] sd-z-10 sd-shadow-[0_3px_8px_#00000040] sd-border  sd-border-n-gray-3 sd-font-pilat  sd-overflow-y-auto sd-max-h-[480px]"
        >
          {!loading &&
          !suggestionLoader &&
          suggestion.nodata &&
          suggestion.noSuggestiondata ? (
            <p className="sd-m-2">No Suggestion</p>
          ) : (
            <>
            {/* <div class="sd-flex sd-justify-between sd-p-4">
            <div className="sd-flex-1">01</div>
            <div className="sd-flex-1">02</div>
            <div className="sd-flex-1">03</div>
          </div> */}
              <div className="lg:sd-flex sd-justify-between sd-divide-x-[1px] sd-py-[20px] lg:sd-py-[0]">


              {((loading || suggestionLoader) || (!loading && suggestion?.suggestion?.length > 0 || !loading && suggestion?.category?.length > 0))  && (

             
              <div className="sd-flex-1 lg:sd-p-[20px] sd-px-[20px]">
                  {/* Skeleton loader for the list */}
                  {(loading || suggestionLoader) && (
                    <>
                      <div className={`sd-mb-6 sd-col-span-8 sd-w-full sd-break-words lg:sd-col-span-12 ${showDivider ? 'sd-border-b sd-border-gray-300' : ''}`}>
                        <h4 className="sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label sd-animate-pulse sd-bg-gray-200 sd-h-5 sd-w-32 rounded"></h4>
                        <div className="sd-w-full">
                          <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4">
                            {Array(5)
                              .fill(0)
                              .map((_, index) => (
                                <li
                                  key={index}
                                  className="sd-col-span-8 lg:sd-col-span-4 sd-mb-4 sd-h-5 sd-bg-gray-200 sd-rounded sd-animate-pulse"
                                ></li>
                              ))}
                          </ul>
                        </div>
                      </div>
                      <div className="sd-mb-6 sd-col-span-8 sd-w-full sd-break-words lg:sd-col-span-12">
                        <h4 className="sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label sd-animate-pulse sd-bg-gray-200 sd-h-5 sd-w-32 rounded"></h4>
                        <div className="sd-w-full">
                          <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 lg:sd-pr-7 sd-pr-2">
                            {Array(5)
                              .fill(0)
                              .map((_, index) => (
                                <li
                                  key={index}
                                  className="sd-col-span-8 lg:sd-col-span-4 sd-mb-4 sd-h-5 sd-bg-gray-200 sd-rounded sd-animate-pulse"
                                ></li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                  {!loading && suggestion?.suggestion?.length > 0 && (
                    <div className={`sd-mb-6 sd-col-span-8 sd-w-full sd-break-words lg:sd-col-span-12 sd-blackhover-listitem ${showDivider ? 'sd-mb-[20px]' : ''}`}>
                      <h3 className="sd-mb-4 sd-titleText sd-titleTextGrey">
                        {t('suggestions')}
                      </h3>

                      
                        <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 sd-pl-1">
                          {suggestion.suggestion.map((item, index) => (
                            <li
                              key={index}
                              className="sd-cursor-pointer sd-col-span-8 lg:sd-col-span-4 sd-mb-4"
                            >
                              <a
                                onClick={(e, item) => {
                                  handleSuggestionClick(e, item);
                                }}
                              >
                                {item.term}
                              </a>
                            </li>
                          ))}
                        </ul>
                      
                    </div>
                  )}

                  {showDivider && (
                    <div className="lg:sd-border-t lg:sd-border-gray-300 lg:sd-pt-5"></div>
                  )}

                  {!loading && suggestion?.category?.length > 0 && (
                    <div className="sd-mb-6 sd-col-span-8 sd-w-full sd-break-words lg:sd-col-span-12">
                      <h3 className="sd-mb-4 sd-titleText sd-titleTextGrey">
                      {t('categories')}
                      </h3>

                      <div className="sd-w-full sd-blackhover-listitem">
                        <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 sd-pl-1">
                          {suggestion.category.map((item, index) => (
                            <li
                              key={index}
                              className="sd-col-span-8 sd-cursor-pointer lg:sd-col-span-4 sd-mb-4"
                            >
                              <a
                                target="_blnk"
                                href={checkReplaceUrl(item.url)}
                              >
                                {item.title}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
 )}




                
                {((suggestion?.product?.length > 0)  ||  (loading || suggestionLoader)) && (
                  <div className="sd-flex-1 lg:sd-p-[20px] sd-px-[20px]">
                  {suggestion?.product?.length > 0 && (
                    <div className="sd-col-span-8 sd-mb-6 sd-w-full sd-break-words lg:sd-col-span-12">
                      {/* <h4 className="sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label ">
                        Products{" "}
                        <span className="sd-underline sd-text-sm sd-font-thin">
                          View All
                        </span>
                      </h4> */}
                      <div className="sd-flex sd-justify-between lg:sd-pr-2 sd-items-center sd-mb-4">
                      <h3 className="sd-titleText sd-titleTextGrey">
                        {t('products')}
                      </h3>
                        <a href={checkReplaceUrl("/search?q=" + searchQuery)} className="sd-font-nb sd-underline hover:sd-no-underline sd-text-[12px]">
                          {t('viewAll')}
                        </a>
                      </div>

                      <div className="sd-grid sd-grid-cols-1 sd-gap-4 sd-grid-rows-[auto]">
                        {suggestion?.product?.map((item) => (
                          <a
                            href={item.url}
                            className="sd-cursor-pointer"
                            target="_blank"
                          >
                            <div
                              className="sd-text-left sd-flex sd-cursor-pointer"
                              key={item?.id}
                            >
                              <div className="sd-bg-gray-300 sd-w-full sd-max-w-[96px] sd-aspect-[1/1] sd-rounded-xs sd-flex sd-items-center sd-justify-center">
                                <img
                                  className="sd-mx-auto sd-p-1 sd-object-contain sd-w-full sd-h-full"
                                  src={checkReplaceUrl(item?.primaryImage)}
                                  alt={item?.title}
                                />
                              </div>
                              <h4 className="sd-font-pilat sd-ml-4 ">
                                {item?.title}
                              </h4>
                            </div>
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                  {(loading || suggestionLoader) && (
                    <div className="sd-col-span-8 sd-w-full sd-break-words lg:sd-col-span-12">
                      <div className="sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label">
                        <div className="sd-h-5 sd-bg-gray-200 sd-rounded sd-animate-pulse sd-w-32"></div>
                      </div>
                      <div className="sd-grid sd-grid-cols-1 sd-gap-2 sd-grid-rows-[auto]">
                        {Array.from({ length: 6 }).map((_, index) => (
                          <div
                            className="sd-text-left sd-flex animate-pulse"
                            key={index}
                          >
                            <div className="sd-bg-gray-200 sd-w-full sd-max-w-[96px] sd-aspect-[1/1]  sd-rounded-xs sd-flex sd-items-center sd-justify-center"></div>
                            <div className="sd-bg-gray-200 sd-h-[16px] sd-w-[80%] sd-rounded sd-mt-2 sd-ml-4"></div>
                            {/* <div className="sd-bg-gray-200 sd-h-[16px] sd-w-[60%] sd-rounded sd-mt-1"></div> */}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                )}


{((loading || suggestionLoader) || (!loading && suggestion?.explore?.length > 0 || !loading && suggestion?.support?.length > 0))  && (

                <div className="sd-flex-1 lg:sd-p-[20px] sd-px-[20px]">
                  {(loading || suggestionLoader) && (
                    <>
                      <div className="sd-mb-6 sd-col-span-8 sd-w-full sd-break-words lg:sd-col-span-12">
                        <h4 className="sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label sd-animate-pulse sd-bg-gray-200 sd-h-5 sd-w-32 rounded"></h4>
                        <div className="sd-w-full">
                          <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 lg:sd-pr-7 sd-pr-2">
                            {Array(5)
                              .fill(0)
                              .map((_, index) => (
                                <li
                                  key={index}
                                  className="sd-col-span-8 lg:sd-col-span-4 sd-mb-4 sd-h-5 sd-bg-gray-200 sd-rounded sd-animate-pulse"
                                ></li>
                              ))}
                          </ul>
                        </div>
                      </div>
                      <div className="sd-mb-6 sd-col-span-8 sd-w-full sd-break-words lg:sd-col-span-12">
                        <h4 className="sd-block sd-mb-2 sd-h-fit sd-text-sm sd-font-medium sd-custom-label sd-animate-pulse sd-bg-gray-200 sd-h-5 sd-w-32 rounded"></h4>
                        <div className="sd-w-full">
                          <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 lg:sd-pr-7 sd-pr-2">
                            {Array(5)
                              .fill(0)
                              .map((_, index) => (
                                <li
                                  key={index}
                                  className="sd-col-span-8 lg:sd-col-span-4 sd-mb-4 sd-h-5 sd-bg-gray-200 sd-rounded sd-animate-pulse"
                                ></li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                  {!loading && suggestion?.explore?.length > 0 && (
                    <div className={`sd-mb-6 sd-col-span-8 sd-w-full sd-break-words lg:sd-col-span-12 ${showDividerExploreSupport ? 'sd-mb-[20px]' : ''}`}>
                      <div className="sd-flex sd-justify-between lg:sd-pr-2 sd-items-center sd-mb-4">
                      <h3 className="sd-titleText sd-titleTextGrey">
                        {t('explore')}
                      </h3>
                        <a href={checkReplaceUrl("/search?q=" + searchQuery)} className="sd-font-nb sd-underline hover:sd-no-underline sd-text-[12px]">
                          {t('viewAll')}
                        </a>
                      </div>


                      <div className="sd-w-full sd-blackhover-listitem">
                        <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 sd-pl-1">
                          {suggestion.explore.map((item, index) => (
                            <li
                              key={index}
                              className="sd-cursor-pointer sd-col-span-8 lg:sd-col-span-4 sd-mb-4"
                            >
                              <a
                                target="_blnk"
                                href={checkReplaceUrl(item.url)}
                              >
                                {item.title[0]}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                  {showDividerExploreSupport && (
                      <div className="lg:sd-border-t lg:sd-border-gray-300 lg:sd-pt-5"></div>
                    )}
                  {!loading && suggestion?.support?.length > 0 && (
                    <div className="sd-mb-6 sd-col-span-8 sd-w-full sd-break-words lg:sd-col-span-12">
                    <div className="sd-flex sd-justify-between lg:sd-pr-2 sd-items-center sd-mb-4">
                      <h3 className="sd-titleText sd-titleTextGrey">
                        {t('support')}
                      </h3>
                        <a href={checkReplaceUrl(
                              "/search-support?q=" + searchQuery
                            )} className="sd-font-nb sd-underline hover:sd-no-underline sd-text-[12px]">
                          {t('viewAll')}
                        </a>
                      </div>

                      <div className="sd-w-full sd-blackhover-listitem">
                        <ul className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-4 sd-pl-1">
                          {suggestion.support.map((item, index) => (
                            <li
                              key={index}
                              className="sd-cursor-pointer sd-col-span-8 lg:sd-col-span-4 sd-mb-4"
                            >
                              <a
                                target="_blnk"
                                href={checkReplaceUrl(item.url)}
                              >
                                {item.title[0]}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default SearchSuggestion;
